import { createContext, useContext, useMemo, useState } from "react";

const SignInSignUpContext = createContext(null);

export const SignInSignUpProvider = (props) => {
    const [activeTab, setActiveTab] = useState('sign-in');
    const [userData, setUserData] = useState({ state: "INITIATED" });

    const singnIn =()=>{
        setUserData({...userData, state: "INITIATED"});
        setActiveTab('sign-in');
    }

    const signUp = ()=>{
        setUserData({...userData, state: "INITIATED"});
        setActiveTab('sign-up');
    }

    const clearUserData = ()=>{
        setUserData({...userData,
            displayName:"",
            userName: "",
            email:"",
            password:"",
            confirmPassword:"",
        });
    }

    const memoObj = useMemo(() => ({userData, setUserData, activeTab, setActiveTab, singnIn, signUp, clearUserData}), [userData, activeTab]);
    return (
        <SignInSignUpContext.Provider value={memoObj}>
            {props.children}
        </SignInSignUpContext.Provider>
    );

}
export const useSignInSignUp = () => {
    return useContext(SignInSignUpContext);
};